module.exports = __webpack_public_path__ + "img/validation.938b7e1d.svg";